<template>
    <div class="base" :class="{'base--active': isMenuActive}">
        <div class="row no-gutters">
            <div class="sidebar col-md-3 col-xl-2 col-12">
                <div class="sidebar__logo">
                    <router-link :to="{ name: 'home' }">
                        <img :src="`${publicPath}img/logo-wit.svg`" alt="" width="225" height="38">
                    </router-link>
                </div>

                <ul class="sidebar__navigation">
                    <router-link :to="{ name: 'home' }" tag="li" active-class="active" exact v-permission:manage_users="currentUser">
                        <a><i class="icon icon-dashboard"></i> Dashboard</a>
                    </router-link>

                    <router-link :to="{ name: 'projects' }" tag="li" active-class="active" v-show="showForCustomer">
                        <a><i class="icon icon-dashboard"></i> Projecten</a>
                    </router-link>

                    <router-link :to="{ name: 'addProject' }" tag="li" active-class="active" v-permission:manage_projects="currentUser">
                        <a><i class="icon icon-add"></i> Project toevoegen</a>
                    </router-link>

                    <router-link :to="{ name: 'schedule' }" tag="li" active-class="active" exact="" v-show="showForInspectors">
                        <a><i class="icon icon-calendar"></i> Geplande opnames</a>
                    </router-link>

                    <router-link :to="{ name: 'scheduleDoing' }" tag="li" active-class="active" v-show="showForInspectors">
                        <a><i class="icon icon-clock"></i> Lopende opnames</a>
                    </router-link>

                    <router-link :to="{ name: 'scheduleFinished' }" tag="li" active-class="active" v-show="showForInspectors">
                        <a><i class="icon icon-check"></i> Afgeronde opnames</a>
                    </router-link>
                </ul>

                <ul class="sidebar__navigation sidebar__navigation--small" v-permission:manage_inspections="currentUser">
                    <li class="title">Snel naar..</li>
                    <router-link :to="{ name: 'projects' }" tag="li" active-class="active">
                        <a>Projecten</a>
                    </router-link>
                </ul>

                <ul class="sidebar__navigation sidebar__navigation--small" v-permission:manage_users="currentUser">
                    <li class="title">Beheer & Administratie</li>
                    <router-link :to="{ name: 'companies' }" tag="li" active-class="active" v-permission:manage_companies="currentUser">
                        <a>Opdrachtgevers</a>
                    </router-link>

                    <router-link :to="{ name: 'users' }" tag="li" active-class="active" v-permission:manage_users="currentUser">
                        <a>Gebruikers</a>
                    </router-link>

                    <router-link :to="{ name: 'roles' }" tag="li" active-class="active" v-permission:manage_roles="currentUser">
                        <a>Rollen & rechten</a>
                    </router-link>
                </ul>
            </div>

            <div class="main col-12 col-md-9 col-xl-10 ml-auto">
                <div class="header">
                    <div class="header__toggle">
                        <button @click.prevent="toggleMenu">
                            <img src="/img/navigation.svg" alt="" width="25" height="25">
                        </button>
                    </div>

                    <ul class="header__meta" v-if="tags.length > 0" v-show="!isMenuActive">
                        <li v-for="tag in tags" :key="tag">{{ tag }}</li>
                    </ul>

                    <ul class="header__navigation">
                        <li>{{ version }}</li>

                        <Notifications></Notifications>

                        <li class="has-dropdown user">
                            <a href="#"><i class="icon icon-user"></i> {{ currentUser.name }}</a>

                            <ul>
                                <router-link :to="{ name: 'myAccount' }" tag="li" active-class="active" exact>
                                    <a>Mijn account</a>
                                </router-link>

                                <li><a href="#" @click.prevent="logout">Uitloggen</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <main :class='{"is-loading": isLoading}'>
                    <router-view></router-view>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
	import Notifications from '@/components/global/Notifications'
	import { mapGetters } from 'vuex'
	import { SET_MENU_ACTIVE } from '@/store/modules/menu'
	import { LOGOUT } from '@/store/modules/authentication'

	export default {
		components: { Notifications },

		data () {
			return {
				publicPath: process.env.BASE_URL,
				version: process.env.VUE_APP_VERSION,
			}
		},

		computed: {
			...mapGetters([
				'currentUser',
				'isLoading',
				'tags',
				'isMenuActive',
			]),

			showForInspectors () {
				if (this.currentUser.roles.length > 0) {
					return (
						this.currentUser.roles.map((role) => {return role.name}).indexOf('Opname expert') !== -1
					)
				}

				return false
			},

			showForCustomer () {
				if (this.currentUser.roles.length > 0) {
					return (
						this.currentUser.roles.map((role) => {return role.name}).indexOf('Opdrachtgever') !== -1
					)
				}

				return false
			},
		},

		methods: {
			logout () {
				this.$store.dispatch(LOGOUT).then(() => {
					this.$router.push({ name: 'login' })
				})
			},

			toggleMenu () {
				this.$store.dispatch(SET_MENU_ACTIVE, !this.isMenuActive)
			},
		},
	}
</script>